import React, { useContext, useState } from 'react';
import { Helmet } from 'react-helmet';
import styles from "./Hiring.module.css";
import video from "../../../assets/Video/hiringVideo.mp4";
import { Link } from 'react-router-dom';

// context
import { UserContext } from '../../Context/UserContextProvider';

import AlreadySignedupModal from '../Consultant/ConsultantSignup/AlreadySignedupModal/AlreadySignedupModal';
import HomeModal from '../HomeModal/HomeModal';
import HomeNavbar from '../HomeNavbar/HomeNavbar';
import Footer from '../Footer/Footer';


export default function Hiring() {
    const { simpleUser, userToken } = useContext(UserContext);
    const [modalShow, setModalShow] = useState(false);
    const [modalShow2, setModalShow2] = useState(false);

    return (
        <>


            <Helmet>
                <title>همکاری با ما | آذر ملک</title>
                <meta name="description" content="همکاری با آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
                <meta name="keywords" content=
                    "اجاره آپارتمان مسکونی در تبریز, رهن آپارتمان مسکونی در تبریز, اجاره آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, اجاره آپارتمان مسکونی در رشدیه  تبریز, رهن آپارتمان مسکونی در رشدیه  تبریز, اجاره آپارتمان مسکونی در زعفرانیه  تبریز, رهن آپارتمان مسکونی در زعفرانیه  تبریز, اجاره آپارتمان مسکونی در مرزداران  تبریز, رهن آپارتمان مسکونی در مرزداران  تبریز, اجاره آپارتمان مسکونی در تبریز, رهن آپارتمان مسکونی در تبریز, اجاره آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, اجاره آپارتمان مسکونی در رشدیه  تبریز, رهن آپارتمان مسکونی در رشدیه  تبریز, اجاره آپارتمان مسکونی در زعفرانیه  تبریز, رهن آپارتمان مسکونی در زعفرانیه  تبریز, اجاره آپارتمان مسکونی در مرزداران  تبریز, رهن آپارتمان مسکونی در مرزداران  تبریز" />
                <meta content="index , follow" name="robots" />
                <meta name="og:title" content="همکاری با آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
                <meta name="description" content="همکاری با آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
                <meta name="og:description" content="همکاری با آذر ملک - خرید، فروش، اجاره و رهن ملک در تبریز" />
                <meta rel="canonical" href="https://azrmelk.com/همکاری-با-ما" />
                <meta content="website" property="og:type" />
                <meta content="https://azrmelk.com" name="twitter:site" />
                <meta content="https://azrmelk.com/همکاری-با-ما" property="og:url" />
            </Helmet>

            <AlreadySignedupModal
                show={modalShow2}
                onHide={() => setModalShow2(false)}
            />

            <HomeModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />

            <div className="d-flex justify-content-center align-items-start vw-100">
                <div className={`${styles.container} w-100 d-flex flex-column align-items-center ms-0 p-0`}>
                    <HomeNavbar Hire />
                    <div className="container py-3 px-0">
                        <div
                            className="w-100 d-flex justify-content-start flex-wrap align-items-center mt-3 px-md-2 px-3"
                            dir="rtl"
                        >
                            <div className='d-flex align-items-center justify-content-center mt-2 mb-4'>
                                <h1 className={styles.title}>
                                    همکاری با ما
                                </h1>
                            </div>
                        </div>
                    </div>
                    <main className='d-flex flex-column w-75 align-items-center justify-content-center px-3 mt-5' style={{ zIndex: "5" }}>
                        <video controls width="100%" height="555px">
                            <source src={video} type="video/mp4" />
                            <source src={video} type="video/mp4"
                            />
                            Sorry, your browser doesn't support videos.
                        </video>
                        <div class="w-100 px-md-4 px-3 my-5 text-wrap text-end">
                            <article dir='rtl' style={{textAlign: "right"}}>
                                <p>طریقه جذب نیرو در آذرملک توسط مدیر منابع انسانی آقای روزبه پورحیدر در این ویدیو گفته شده است.</p>
                                <p><a title="استخدام آذرملک تبریز ولیعصر" href="https://www.aparat.com/v/vCaqR" target="_blank" rel="noopener">https://www.aparat.com/v/vCaqR</a></p>
                                <p>&nbsp;خانواده بزرگ آذر ملک از افراد واجد شرایط و جویای کار با مشخصات ذیل دعوت به همکاری مینماید</p>
                                <p>&nbsp;رده سنی: 25 الی 45</p>
                                <p>تحصیلات: حداقل لیسانس</p>
                                <p>الویت: رشته های عمران، معماری، مدیریت، بازاریابی، حقوق</p>
                                <p>نحوه همکاری: تمام وقت</p>
                                <p>حقوق: پورسانتی</p>
                                <p>___________________________</p>
                                <p>امکانات مجموعه: سیستم دپارتمانی اتاق جلسه VIP مدیر قرارداد و متخصص حقوقی تسویه آنی <a href="https://www.aparat.com/v/vCaqR?t=120">13:50</a></p>
                                <p>سوالات متداول</p>
                                <p>تایم کاری: 10 صبح تا 9 شب</p>
                                <p>تایم&zwnj;استراحت: 14 الی 17</p>
                                <p>نحوه همکاری: فقط تمام وقت</p>
                                <p>حقوق: 40 الی 50 درصد از کمسیون دریافتی از هر معامله</p>
                                <p>تسویه: پس دریافت وجه از دو طرف معامله درجا تسویه خواهد شد</p>
                                <p>آموزش: صفر تا صد کارهای ملکی و اصول معامله در طی یک هفته آموزش داده خواهد شد</p>
                                <p>شروع همکاری: طی یک قرارداد کاری و به مدت یک الی سه ماه به صورت آزمایشی</p>
                                <p>آذرملک_تبریز</p>
                                <div className='w-100 d-flex justify-content-center'>
                                    {simpleUser?.roles == ""
                                        ?
                                        <Link to="/consultant-signup" className={`d-flex align-items-center justify-content-center ${styles.btn}`} >
                                            شروع همکاری
                                        </Link>
                                        :
                                        userToken ?
                                            <button onClick={() => setModalShow2(true)} className={`d-flex align-items-center justify-content-center pointer ${styles.btn}`}>
                                                شروع همکاری
                                            </button>
                                            :
                                            <button onClick={() => setModalShow(true)} className={`d-flex align-items-center justify-content-center pointer ${styles.btn}`}>
                                                شروع همکاری
                                            </button>
                                    }
                                </div>
                            </article>
                        </div>
                    </main>
                </div>
            </div>
            <Footer />
        </>
    )
}
